import { cn } from "../../lib/cn";

/** Eduleo OS lockup: mark + "Eduleo" in navy + "OS" in logo blue. */
export function Logo({
  className,
  showTagline = false,
}: {
  className?: string;
  showTagline?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <img src="/logo-mark.png" alt="" width={36} height={36} className="size-9 rounded-[10px]" />
      <span className="flex flex-col leading-none">
        <span className="font-extrabold text-[19px] text-navy tracking-tight">
          Eduleo <span className="text-brand-logo">OS</span>
        </span>
        {showTagline && (
          <span className="mt-1 text-2xs text-ink-3">School Management, Simplified.</span>
        )}
      </span>
    </span>
  );
}
